<template>
  <l-tile-layer ref="sceneLayer" :key="templateName" :tile-layer-class="tileLayer"></l-tile-layer>
</template>

<script>
import Tangram from 'tangram/dist/tangram.min';
import {LTileLayer} from 'vue2-leaflet'

export default {
  name: "TxTileLayer",
  props: {
    templateName: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      tileClass: null,
    }
  },
  components: {
    LTileLayer,
  },
  mounted() {
    this.sceneLayer = this.$refs.sceneLayer.mapObject.scene
  },
  methods: {
    tileLayer() {
      let test = {
        sceneBasePath: this.$root.lovemap.sceneBasePath + `/${this.templateName}/`,
        scene: this.$root.lovemap.sceneBasePath + `/${this.templateName}/` + 'scene.yaml', // simple demo scene
        events: {
          hover: this.onHover,
          click: this.onClick
        }
      }
      return new Tangram.leafletLayer(test);
    },
    onHover(selection) {
      this.$emit('sceneHover', selection)
    },
    onClick(selection) {
      this.$emit('sceneClick', selection)
    }
  },
}
</script>

<style scoped>

</style>